// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2WAdoO7q-6_MJE {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"canonicalCard": "_2WAdoO7q-6_MJE"
};
export default ___CSS_LOADER_EXPORT___;
